/**
* 基础菜单 API类型管理
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="rawValue1" auto-complete="off" clearable
                  placeholder="请输入API类型"></el-input>
<!--        <el-select v-model="formInline.groupId" placeholder="请选择API类型" clearable-->
<!--                   @change="changeApiType1(formInline.groupId)" @clear="clearApiType1()">-->
<!--          <el-option v-for="item in ApiType" :key="item.id" :label="item.group_name"-->
<!--                     :value="item.id"></el-option>-->
<!--        </el-select>-->
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="rawValue2" auto-complete="off" clearable
                  placeholder="请输入API栏目"></el-input>
<!--        <el-select v-model="formInline.sortId" placeholder="请选择API栏目" clearable>-->
<!--          <el-option v-for="item in ApiColumn1" :key="item.id" :label="item.sort_name"-->
<!--                     :value="item.id"></el-option>-->
<!--        </el-select>-->
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="rawValue3" auto-complete="off" clearable
                  placeholder="请输入API名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.isFree" placeholder="是否免费" clearable>
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.isLimit" placeholder="有无调用限制" clearable>
          <el-option label="有" value="1"></el-option>
          <el-option label="无" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.status" placeholder="有效状态" clearable>
          <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="primary" @click="addButton" class="add-button">新增</el-button>
        <el-button size="small" type="primary" @click="editButton" class="edit-button">修改</el-button>
        <el-button size="small" type="warning" @click="publish">发布</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="group_name" label="API类型" min-width="120" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="sort_name" label="API栏目" width="120" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="doc_name" label="API名称" width="280" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="is_recommend" label="是否推荐" width="90">
          <template slot-scope="scope">
            <div v-if="scope.row.is_recommend==1">是</div>
            <div v-else>否</div>
          </template>
        </el-table-column>
        <el-table-column prop="is_free" label="是否免费" width="90">
          <template slot-scope="scope">
            <div v-if="scope.row.is_free==1">是</div>
            <div v-else>否</div>
          </template>
        </el-table-column>
        <el-table-column prop="is_limit" label="有无调用限制" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.is_limit==1">有</div>
            <div v-else>无</div>
          </template>
        </el-table-column>
        <el-table-column prop="version" label="版本号" width="90">
        </el-table-column>
        <el-table-column prop="creater" label="上次编辑人" width="120" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="update_time" label="上次编辑时间" width="135" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div>{{scope.row.update_time|timestampToTime}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="scope">
            <el-switch @change="changeStatus(scope.row.id,scope.row.status)"
                       v-model="scope.row.status"
                       :active-value="1"
                       :inactive-value="0"
                       active-color="#409EFF">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column align="left" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="success" size="mini" style="margin-right: 8px"
                       @click="setApiDetail(scope.row.id)">
              配置API详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="addDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form label-width="155px" :model="addForm" :rules="rules" ref="addForm" class="addForm">
        <el-form-item label="API类型" prop="group_id">
          <el-select v-model="addForm.group_id" placeholder="请选择API类型" clearable
                     @change="changeApiType(addForm.group_id)" @clear="clearApiType2()">
            <el-option style="width: 320px" v-for="item in ApiType" :key="item.id" :label="item.group_name"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="API栏目" prop="sort_id">
          <el-select v-model="addForm.sort_id" placeholder="请选择API栏目" clearable>
            <el-option v-for="item in ApiColumn" :key="item.id" :label="item.sort_name"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="API名称" prop="doc_name" class="relative r50">
          <el-input size="small" v-model="addForm.doc_name" auto-complete="off" clearable maxlength="50"
                    placeholder="请输入API名称"></el-input>
        </el-form-item>
        <el-form-item label="是否免费" prop="is_free">
          <el-select v-model="addForm.is_free" placeholder="请选择是否免费" clearable>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有无调用限制" prop="is_limit">
          <el-select v-model="addForm.is_limit" placeholder="请选择有无调用限制" clearable>
            <el-option label="有" value="1"></el-option>
            <el-option label="无" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本号" prop="version" class="relative r50">
          <el-input size="small" v-model="addForm.version" auto-complete="off" clearable maxlength="10"
                    placeholder="请输入版本号"></el-input>
        </el-form-item>
        <el-form-item label="是否推荐" prop="is_recommend">
          <el-select v-model="addForm.is_recommend" placeholder="请选择是否推荐" clearable>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序号" prop="seq" class="relative r50">
          <el-input size="small" v-model="addForm.seq" auto-complete="off" clearable maxlength="8"
                    placeholder="请输入排序号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveButton('addForm')" :disabled="!isCanSubmit">保存</el-button>
            <el-button @click="handleClose()">取 消</el-button>
      </span>
    </el-dialog>

    <!--    配置API信息-->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="配置API信息"
               :visible.sync="groundingDialogVisible"
               width="80%"
               center>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="API基本信息" name="first">
          <el-form label-width="120px" :model="infoForm" :rules="rules" ref="infoForm" class="infoForm">
            <el-form-item label="API类型" prop="group_name">
              <el-input size="small" v-model="infoForm.group_name" disabled
                        placeholder="请输入API名称"></el-input>
            </el-form-item>
            <el-form-item label="API栏目" prop="sort_name">
              <el-input size="small" v-model="infoForm.sort_name" disabled
                        placeholder="请输入API栏目"></el-input>
            </el-form-item>
            <el-form-item label="API名称" prop="doc_name" class="relative r50">
              <el-input size="small" v-model="infoForm.doc_name" disabled
                        placeholder="请输入API名称"></el-input>
            </el-form-item>
            <el-form-item label="是否免费" prop="is_free">
              <el-select v-model="infoForm.is_free" placeholder="请选择是否免费" disabled>
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="有无调用限制" prop="is_limit">
              <el-select v-model="infoForm.is_limit" placeholder="请选择有无调用限制" disabled>
                <el-option label="有" value="1"></el-option>
                <el-option label="无" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="版本号" prop="version" class="relative r50">
              <el-input size="small" v-model="infoForm.version" auto-complete="off" disabled
                        placeholder="请输入版本号"></el-input>
            </el-form-item>
            <el-form-item label="方法名称" prop="method" class="relative r50">
              <el-input size="small" v-model="infoForm.method" auto-complete="off" clearable maxlength="45"
                        placeholder="请输入方法名称"></el-input>
            </el-form-item>
            <el-form-item label="使用场景" prop="scene" class="relative r50">
              <el-input size="small" v-model="infoForm.scene" auto-complete="off" clearable maxlength="200"
                        placeholder="请输入使用场景"></el-input>
            </el-form-item>
            <el-form-item label="是否推荐" prop="is_recommend">
              <el-select v-model="infoForm.is_recommend" placeholder="请选择是否推荐" disabled>
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序号" prop="seq" class="relative r50">
              <el-input size="small" v-model="infoForm.seq" disabled placeholder="请输入排序号"></el-input>
            </el-form-item>
          </el-form>
          <div style="text-align: center">
            <el-button type="primary" size="mini" @click="saveOneTab()"
                       style="width: 80px">保存
            </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="公共参数" name="second">
          <!--列表-->
          <div class="scrollbar mt20" style="max-height: 580px;overflow-y: auto">
            <el-form label-width="120px" :model="secondForm" :rules="rules" ref="secondForm" class="infoForm">
              <el-form-item label="请求地址" prop="product_name">
                <div>{{product_name}}</div>
              </el-form-item>
              <el-form-item label="测试环境地址" prop="name">
                <el-input size="small" v-model="secondForm.test_url" disabled
                          placeholder="请输入测试环境地址"></el-input>
              </el-form-item>
              <el-form-item label="生产环境地址" prop="name">
                <el-input size="small" v-model="secondForm.prod_url" disabled
                          placeholder="请输入生产环境地址"></el-input>
              </el-form-item>
            </el-form>
            <p class="title f20 color333 mb20 f700">公共请求参数</p>
            <el-table size="small" :data="secondTableData" highlight-current-row v-loading="loading" border
                      element-loading-text="拼命加载中" style="width: 100%;margin-bottom: 20px;">
              <el-table-column prop="model" label="名称" min-width="120">
                <template slot-scope="scope" style="position: relative">
                  <el-input v-model="scope.row.name" placeholder="名称" maxLength="30" disabled :title="scope.row.name"
                            clearable></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="model" label="类型" min-width="120" :show-overflow-tooltip='true'>
                <template slot-scope="scope" style="position: relative">
                  <el-input v-model="scope.row.type" placeholder="类型" maxLength="20" disabled
                            clearable></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="must" label="是否必须" min-width="120" :show-overflow-tooltip='true'>
                <template slot-scope="scope" style="position: relative">
                  <el-select v-model="scope.row.must" placeholder="请选择是否必须" disabled>
                    <el-option v-for="item in negoList" :key="item.value" :label="item.name"
                               :value="item.value"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="desc" label="描述" min-width="120" :show-overflow-tooltip='true'>
                <template slot-scope="scope" style="position: relative">
                  <el-input v-model="scope.row.desc" placeholder="描述" maxLength="30" disabled :title="scope.row.desc"
                            clearable></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="请求参数" name="third">
          <el-table size="small" :data="modelData4" highlight-current-row v-loading="loading" border
                    @selection-change="handleSelectionChange" row-key="id"
                    default-expand-all
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    :expand-row-keys="expandRowKeys"
                    @row-click="(row, column, e) => clickRowLoad(row, column, e)"
                    :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                    element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column
              type="index"
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column prop="name" label="参数名称" min-width="220">
              <template slot-scope="scope" style="position: relative">
                <el-input v-model="scope.row.name" :disabled="!scope.row.isShow4" placeholder="参数名称" maxLength="30"
                          style="width: 150px"
                          clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="类型" width="120">
              <template slot-scope="scope" style="position: relative">
                <el-input v-model="scope.row.type" :disabled="!scope.row.isShow4" placeholder="类型" maxLength="20"
                          clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="must" label="是否必须" width="135">
              <template slot-scope="scope" style="position: relative">
                <el-select v-model="scope.row.must" placeholder="是否必须" :disabled="!scope.row.isShow4">
                  <el-option v-for="item in negoList" :key="item.value" :label="item.name"
                             :value="item.value"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="desc" label="描述" min-width="270" :show-overflow-tooltip='true'>
              <template slot-scope="scope" style="position: relative">
                <el-input v-model="scope.row.desc" :disabled="!scope.row.isShow4" placeholder="描述" maxLength="100"
                          clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="300">
              <template slot-scope="scope">
                <el-button type="primary" plain size="mini"
                           @click.native.prevent="saveDetail4(scope.$index,scope.row)" v-if="scope.row.isShow4"
                           style="width: 80px">保存
                </el-button>
                <el-button type="primary" plain size="mini"
                           @click.native.prevent="editDetail4(scope.$index,scope.row)" v-if="!scope.row.isShow4"
                           style="width: 80px">编辑
                </el-button>
                <el-button type="success" plain size="mini" @click="addChildren(scope.$index,scope.row,'4')"
                           style="width: 80px">新增子项
                </el-button>
                <el-button type="danger" plain size="mini"
                           @click.native.prevent="deleteRow4(scope.$index,scope.row)"
                           style="width: 80px">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="stions">
            <el-button type="primary" plain @click="addModelDetail4">新增请求参数</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="响应参数" name="fourth">
          <div class="mb20">响应参数:</div>
          <el-table size="small" :data="modelData5" highlight-current-row v-loading="loading" border
                    @selection-change="handleSelectionChange" row-key="id"
                    default-expand-all
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    :expand-row-keys="expandRowKeys"
                    @row-click="(row, column, e) => clickRowLoad(row, column, e)"
                    :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                    element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column
              type="index"
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column prop="name" label="参数名称" min-width="220">
              <template slot-scope="scope" style="position: relative">
                <el-input v-model="scope.row.name" :disabled="!scope.row.isShow5
                          ||(scope.row.pid=='0'&&scope.row.name=='msg')
                          ||(scope.row.pid=='0'&&scope.row.name=='code')
                          ||(scope.row.pid=='0'&&scope.row.name=='content')
                          ||(scope.row.pid=='0'&&scope.row.name=='traceId')"
                          placeholder="参数名称" maxLength="30"
                          style="width: 150px"
                          clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="类型" width="120">
              <template slot-scope="scope" style="position: relative">
                <el-input v-model="scope.row.type"
                          :disabled="!scope.row.isShow5
                          ||(scope.row.pid=='0'&&scope.row.name=='msg')
                          ||(scope.row.pid=='0'&&scope.row.name=='code')
                          ||(scope.row.pid=='0'&&scope.row.name=='content')
                          ||(scope.row.pid=='0'&&scope.row.name=='traceId')"
                          placeholder="类型" maxLength="20"
                          clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="desc" label="描述" min-width="270" :show-overflow-tooltip='true'>
              <template slot-scope="scope" style="position: relative">
                <el-input v-model="scope.row.desc" :disabled="!scope.row.isShow5" placeholder="描述" maxLength="100"
                          clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column align="left" label="操作" width="300">
              <template slot-scope="scope">
                <el-button type="primary" plain size="mini"
                           @click.native.prevent="saveDetail5(scope.$index,scope.row)" v-if="scope.row.isShow5"
                           style="width: 80px">保存
                </el-button>
                <el-button type="primary" plain size="mini"
                           @click.native.prevent="editDetail5(scope.$index,scope.row)" v-if="!scope.row.isShow5"
                           style="width: 80px">编辑
                </el-button>
                <el-button type="success" plain size="mini" @click="addChildren(scope.$index,scope.row,'5')"
                           v-if="(scope.row.pid!='0'&&scope.row.name!='code')||(scope.row.pid!='0'&&scope.row.name!='traceId')||(scope.row.pid!='0'&&scope.row.name!='msg')||(scope.row.pid=='0'&&scope.row.name=='content')"
                           style="width: 80px">新增子项
                </el-button>
                <el-button type="danger" plain size="mini"
                           @click.native.prevent="deleteRow5(scope.$index,scope.row)"
                           v-if="(scope.row.pid!='0'&&scope.row.name!='code')||(scope.row.pid!='0'&&scope.row.name!='traceId')||(scope.row.pid!='0'&&scope.row.name!='msg')||(scope.row.pid!='0'&&scope.row.name!='content')"
                           style="width: 80px">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="响应示例" name="fifth">
          <div class="inline_block">
            <el-form :model="fifthForm" :rules="fifthRules" ref="fifthForm" label-width="125px" class="brandForm">
              <el-form-item label="响应示例" prop="name" class="discuss">
                <el-input
                  type="textarea"
                  placeholder="请输入响应示例内容"
                  v-model="fifthForm.name"
                  :autosize="{ minRows: 10, maxRows: 12}"
                  show-word-limit
                  maxlength="200"
                  resize="none"
                  auto-complete="off"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="text-align: center">
            <el-button type="primary" size="mini" @click="saveFiveTab('fifthForm')"
                       style="width: 80px">保存
            </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="异常示例" name="sixth">
          <div class="inline_block">
            <el-form :model="sixthForm" :rules="sixthRules" ref="sixthForm" label-width="125px" class="brandForm">
              <el-form-item label="异常示例" prop="name" class="discuss">
                <el-input
                  type="textarea"
                  placeholder="请输入异常示例内容"
                  v-model="sixthForm.name"
                  :autosize="{ minRows: 10, maxRows: 12}"
                  show-word-limit
                  maxlength="200"
                  resize="none"
                  auto-complete="off"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="text-align: center">
            <el-button type="primary" size="mini" @click="saveSixTab('sixthForm')"
                       style="width: 80px">保存
            </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="错误码" name="seventh">
          <p class="title f20 color333 mb20 f700">错误码</p>
          <el-table size="small" :data="modelData2" highlight-current-row v-loading="loading" border
                    element-loading-text="拼命加载中" style="width: 100%;margin-bottom: 20px;">
            <el-table-column
              type="index"
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column prop="error_code" label="错误码" min-width="120" :show-overflow-tooltip='true'>
              <template slot-scope="scope" style="position: relative">
                <el-input v-model="scope.row.error_code" :disabled="!scope.row.isShow2" placeholder="错误码" maxLength="30"
                          clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="error_desc" label="错误描述" min-width="120" :show-overflow-tooltip='true'>
              <template slot-scope="scope" style="position: relative">
                <el-input v-model="scope.row.error_desc" :disabled="!scope.row.isShow2" placeholder="错误描述"
                          maxLength="30"
                          clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="220">
              <template slot-scope="scope">
                <el-button type="primary" plain size="mini"
                           @click.native.prevent="saveDetail2(scope.row.id,scope.$index,scope.row.isShow2)"
                           v-if="scope.row.isShow2"
                           style="width: 80px">保存
                </el-button>
                <el-button type="primary" plain size="mini"
                           @click.native.prevent="editDetail2(scope.row.id,scope.$index,scope.row.isShow2)"
                           v-if="!scope.row.isShow2"
                           style="width: 80px">编辑
                </el-button>
                <el-button type="danger" plain size="mini"
                           @click.native.prevent="deleteRow2(scope.row.id,scope.$index,modelData2)"
                           style="width: 80px">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="stions">
            <el-button type="primary" plain @click="addModelDetail2" v-if="isShowAdd2">新增错误码</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="常见Q&A" name="eighth">
          <p class="title f20 color333 mb20 f700">常见Q&A</p>
          <el-table size="small" :data="modelData3" highlight-current-row v-loading="loading" border
                    element-loading-text="拼命加载中" style="width: 100%;margin-bottom: 20px;">
            <el-table-column
              type="index"
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column prop="question" label="问题" min-width="120" :show-overflow-tooltip='true'>
              <template slot-scope="scope" style="position: relative">
                <el-input v-model="scope.row.question" :disabled="!scope.row.isShow3" placeholder="问题" maxLength="30"
                          clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="solution" label="解决方案" min-width="120" :show-overflow-tooltip='true'>
              <template slot-scope="scope" style="position: relative">
                <el-input v-model="scope.row.solution" :disabled="!scope.row.isShow3" placeholder="解决方案" maxLength="30"
                          clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="220">
              <template slot-scope="scope">
                <el-button type="primary" plain size="mini"
                           @click.native.prevent="saveDetail3(scope.row.id,scope.$index,scope.row.isShow3)"
                           v-if="scope.row.isShow3"
                           style="width: 80px">保存
                </el-button>
                <el-button type="primary" plain size="mini"
                           @click.native.prevent="editDetail3(scope.row.id,scope.$index,scope.row.isShow3)"
                           v-if="!scope.row.isShow3"
                           style="width: 80px">编辑
                </el-button>
                <el-button type="danger" plain size="mini"
                           @click.native.prevent="deleteRow3(scope.row.id,scope.$index,modelData3)"
                           style="width: 80px">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="stions">
            <el-button type="primary" plain @click="addModelDetail3" v-if="isShowAdd3">新增Q&A</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
  import {
    docList,
    docGroupList,
    docSortList,
    docAdd,
    docUpdate,
    docDetail,
    docListPubParam,
    docUpdateQa,
    docAddQa,
    docListQaDetail,
    docListQaDelete,
    docAddErrorCode,
    docUpdateErrorCode,
    docListErrorCode,
    docErrorCodeDelete,
    docAddReqParam,
    docUpdateReqParam,
    docListReqParam,
    docReqParamDelete,
    docAddResParam,
    docUpdateResParam,
    docListResParam,
    docResParamDelete,
    docInitRespInst,
    docRelease
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'

  export default {
    data: () => {
      var validateSeq = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入排序号'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('排序号请输入正整数'));
        } else {
          return callback();
        }
      };
      return {
        loading: false, //是显示加载
        addDialogVisible: false,  // 弹窗
        groundingDialogVisible: false,
        dialogTitle: '',  // 标题
        selectTableData: [],
        tableData: [],
        docId: '',
        modelData: [],
        modelData2: [],
        modelData3: [],
        modelData4: [],
        modelData5: [],
        formInline: {
          pageNo: 1,
          pageSize: 10,
          groupId: '',
          status: '',
          sortId: '',
          docName: '',
          isFree: '',
          isLimit: '',
          groupName:'',
          sortName:''
        },
        addForm: {
          group_id: "",
          sort_id: "",
          doc_name: "",
          is_free: 0,
          is_limit: 0,
          is_recommend: 0,
          version: "",
          status: 0,
          seq: ""
        },
        infoForm: {
          id:'',
          group_name: '',
          sort_name: '',
          doc_name: '',
          is_free: '',
          is_limit: '',
          is_recommend: '',
          version: '',
          status: 1,
          seq: '',
          method: '',
          scene: '',
          resp_inst: '',
          ex_inst: ''
        },
        secondForm: {
          id: '',
          test_url: '',
          prod_url: ''
        },
        secondTableData: [],
        thirdTableData: [],
        fifthForm: {
          id: '',
          name: ''
        },
        sixthForm: {
          id: '',
          name: ''
        },
        rules: {
          group_id: [{required: true, message: '请选择API类型', trigger: 'blur'}],
          sort_id: [{required: true, message: '请选择API栏目', trigger: 'blur'}],
          doc_name: [{required: true, message: '请输入API名称', trigger: 'blur'}],
          is_free: [{required: true, message: '请选择是否免费', trigger: 'change'}],
          is_limit: [{required: true, message: '请选择有无调用限制', trigger: 'change'}],
          version: [{required: true, message: '请输入版本号', trigger: 'blur'}],
          is_recommend: [{required: true, message: '请选择是否推荐', trigger: 'change'}],
          seq: [{required: true, validator:validateSeq,trigger: 'blur'}],
        },
        fifthRules: {
          name: [{required: true, message: '请输入响应示例内容', trigger: 'blur'}],
        },
        sixthRules: {
          name: [{required: true, message: '请输入异常示例内容', trigger: 'blur'}],
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        isCanSubmit: true,
        statusList: [{
          name: '有效',
          value: 1
        }, {
          name: '无效',
          value: 0
        }],
        negoList: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        ApiType: [],
        ApiColumn: [],
        ApiColumn1: [],
        obj: {
          isShow: true
        },
        obj2: {
          error_code: '',
          error_desc: '',
          isShow2: true
        },
        obj3: {
          question: '',
          solution: '',
          isShow3: true
        },
        obj4: {
          id: '',
          pid: '0',
          name: '',
          type: '',
          desc: '',
          must: '',
          isShow4: true,
        },
        obj5: {
          id: '',
          pid: '0',
          name: '',
          type: '',
          desc: '',
          must: 0,
          isShow5: true,
        },
        childrenObj: {
          id: '',
          name: '',
          type: '',
          desc: '',
          isShow4: true
        },
        childrenObj5: {
          id: '',
          name: '',
          type: '',
          desc: '',
          isShow5: true
        },
        isShowAdd: true,
        isShowAdd2: true,
        isShowAdd3: true,
        isShowAdd5: true,
        activeName: 'first',
        product_name: '',
        expandRowKeys: [],
        rawValue1:'',
        rawValue2:'',
        rawValue3:'',
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getData(this.formInline)
      this.getApiDocGroupList();
    },
    computed: {
      groupName: {
        // 当rawValue更新时，进行encodeURIComponent转换
        get() {
          return this.rawValue1 ? encodeURIComponent(this.rawValue1) : '';
        },
        // 当输入框失去焦点时，更新rawValue，并对其进行decodeURIComponent转换
        set(value) {
          this.rawValue1 = value ? decodeURIComponent(value) : '';
        }
      },
      sortName: {
        // 当rawValue更新时，进行encodeURIComponent转换
        get() {
          return this.rawValue2 ? encodeURIComponent(this.rawValue2) : '';
        },
        // 当输入框失去焦点时，更新rawValue，并对其进行decodeURIComponent转换
        set(value) {
          this.rawValue2 = value ? decodeURIComponent(value) : '';
        }
      },
      docName: {
        // 当rawValue更新时，进行encodeURIComponent转换
        get() {
          return this.rawValue3 ? encodeURIComponent(this.rawValue3) : '';
        },
        // 当输入框失去焦点时，更新rawValue，并对其进行decodeURIComponent转换
        set(value) {
          this.rawValue3 = value ? decodeURIComponent(value) : '';
        }
      }
    },
    methods: {
      clickRowLoad(r, c, e) {
        if (e.currentTarget && e.currentTarget.firstElementChild.firstElementChild.firstElementChild) {
          console.log(e.currentTarget, 'e.currentTarget')
          if (e.currentTarget.firstElementChild.firstElementChild.firstElementChild.tagName == 'DIV') {
            e.currentTarget.firstElementChild.firstElementChild.firstElementChild.click()
          } else {
            e.currentTarget.firstElementChild.firstElementChild.firstElementChild.nextElementSibling.click()
          }
        }
      },
      addChildren(index, row, type) {
        if (!row.name) {
          this.$message({
            type: 'info',
            message: '参数名称不能为空'
          })
          return
        }
        if (!row.type) {
          this.$message({
            type: 'info',
            message: '类型不能为空'
          })
          return
        }
        if (row.must !== 0 && row.must !== 1 && type == 4) {
          this.$message({
            type: 'info',
            message: '是否必须不能为空'
          })
          return
        }
        if (!row.children) {
          this.$set(row, 'children', []);
        }
        if (type == 4) {
          this.childrenObj.doc_id = this.docId;
          this.childrenObj.pid = row.id;
          row.children.push(JSON.parse(JSON.stringify(this.childrenObj)))
        } else if (type == 5) {
          this.childrenObj5.doc_id = this.docId;
          this.childrenObj5.pid = row.id;
          row.children.push(JSON.parse(JSON.stringify(this.childrenObj5)))
        }
      },
      // 新增API类型
      addButton() {
        this.addDialogVisible = true;
        this.dialogTitle = '新增开发文档';
        this.getApiDocGroupList();
        this.addForm = {
          group_id: "",
          sort_id: "",
          doc_name: "",
          is_free: '1',
          is_limit: '0',
          is_recommend: '0',
          version: "",
          status: 1,
          seq: ""
        };
      },
      // 修改API类型
      editButton() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.dialogTitle = '修改开发文档';
        this.addDialogVisible = true;
        this.getApiDocGroupList()
        docDetail(this.selectTableData[0].id)
          .then(res => {
            if (res.success) {
              this.addForm = {
                group_id: res.content.group_id,
                sort_id: "",
                doc_name: res.content.doc_name,
                is_free: res.content.is_free.toString(),
                is_limit: res.content.is_limit.toString(),
                is_recommend: res.content.is_recommend.toString(),
                version: res.content.version,
                status: 1,
                seq: res.content.seq
              };
              this.changeApiType(res.content.group_id, res.content.sort_id)
            }
          })
          .catch(err => {
          })
        this.docId = this.selectTableData[0].id;
      },
      getApiDocGroupList() {
        let body = {
          groupName: '',
          status: '1',
          pageSize: '100',
          pageNo: '1'
        }
        docGroupList(body)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.ApiType = res.content.rows
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      changeApiType(id, sort_id) {
        if (id) {
          docSortList(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                if (res.content.rows.length) {
                  this.ApiColumn = res.content.rows
                  if (sort_id) {
                    this.addForm.sort_id = sort_id
                  }
                }
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
          this.$set(this.addForm, 'sort_id', '')
          this.ApiColumn = []
        }
      },
      changeApiType1(id) {
        if (id) {
          docSortList(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                if (res.content.rows.length) {
                  this.ApiColumn1 = res.content.rows
                }
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
          this.$set(this.formInline, 'sortId', '')
          this.ApiColumn1 = []
        }
      },
      clearApiType1() {
        this.ApiColumn = [];
        this.$set(this.formInline, 'sortId', '')
      },
      clearApiType2() {
        this.ApiColumn = [];
        this.$set(this.addForm, 'sort_id', '')
      },
      changeStatus(id, status) {
        if (!status) {
          let body = {
            id: id,
            status: 0
          }
          docUpdate(body)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '已将状态设置为无效!'
                });
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          let body = {
            id: id,
            status: 1
          }
          docUpdate(body)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '已将状态设置为有效!'
                });
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      // 获取公司列表
      getData(parameter) {
        this.loading = true
        parameter.groupName = this.groupName;
        parameter.sortName = this.sortName;
        parameter.docName = this.docName;
        docList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.pageNo
              this.pageparm.pageSize = this.formInline.pageSize
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        console.log(parm)
        this.formInline.pageNo = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getData(this.formInline)
      },
      // 新增API类型
      saveButton(formName) {
        if (this.dialogTitle == '修改开发文档') {
          this.addForm.id = this.productId;
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            if (this.dialogTitle == '新增开发文档') {
              docAdd(this.addForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功增加开发文档!'
                    });
                    this.handleClose()
                    this.getData(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            } else {
              this.addForm.id = this.docId;
              docUpdate(this.addForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改开发文档!'
                    });
                    this.handleClose()
                    this.getData(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      // 搜索事件
      search() {
        this.formInline.pageNo = 1;
        this.getData(this.formInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      handleClose() {
        this.$refs["addForm"].resetFields();
        this.addDialogVisible = false;
      },
      // tab页
      handleClick(tab) {
        console.log(tab.index)
        if (tab.index == 1) {
          docListPubParam().then(res => {
            if (res.success) {
              this.secondForm = res.content.requrl;
              this.secondTableData = res.content.pubparamList
            }
          })
        } else if (tab.index == 7) {
          this.getDocListQaDetail()
        } else if (tab.index == 6) {
          this.getDocListErrorCode()
        } else if (tab.index == 2) {
          this.getReqParamList()
        } else if (tab.index == 3) {
          this.getResParamList()
        }
      },
      //获取请求参数
      getReqParamList() {
        this.modelData4 = [];
        docListReqParam(this.docId)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content) {
                res.content.forEach((item) => {
                  item.isShow4 = false;
                  this.modelData4.push(item)
                })
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      //获取响应参数
      getResParamList() {
        this.modelData5 = [];
        docListResParam(this.docId)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content) {
                res.content.forEach((item) => {
                  item.isShow5 = false;
                  this.modelData5.push(item)
                })
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      getDocListErrorCode() {
        this.modelData2 = [];
        docListErrorCode(this.docId)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content) {
                res.content.forEach((item) => {
                  item.isShow2 = false;
                  this.modelData2.push(item)
                })
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      getDocListQaDetail() {
        this.modelData3 = [];
        docListQaDetail(this.docId)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content) {
                res.content.forEach((item) => {
                  item.isShow3 = false;
                  this.modelData3.push(item)
                })
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 配置API信息
      setApiDetail(id) {
        this.groundingDialogVisible = true;
        this.docId = id;
        this.activeName = 'first';
        this.isShowAdd = true;
        this.isShowAdd2 = true;
        this.isShowAdd3 = true;
        this.isShowAdd5 = true;
        this.secondForm = {
          id: '',
          name: ''
        };
        this.fifthForm = {
          id: '',
          name: ''
        };
        this.sixthForm = {
          id: '',
          name: ''
        };
        this.modelData = [];
        this.modelData2 = [];
        this.modelData3 = [];
        docDetail(id)
          .then(res => {
            if (res.success) {
              this.infoForm = {
                group_name: res.content.group_name,
                sort_name: res.content.sort_name,
                doc_name: res.content.doc_name,
                is_free: res.content.is_free.toString(),
                is_limit: res.content.is_limit.toString(),
                is_recommend: res.content.is_recommend.toString(),
                version: res.content.version,
                status: 1,
                seq: res.content.seq,
                method: res.content.method,
                scene: res.content.scene
              };
              let obj1 = eval("(" + res.content.resp_inst + ")")
              let obj2 = eval("(" + res.content.ex_inst + ")")
              let formattedJson1 = JSON.stringify(obj1, null, 4)
              let formattedJson2 = JSON.stringify(obj2, null, 4)
              this.fifthForm.name = formattedJson1;
              this.sixthForm.name = formattedJson2;
            }
          })
          .catch(err => {
          })
        docListPubParam().then(res => {
          if (res.success) {

          }
        })
      },
      // 公告参数保存
      saveDetail(index) {
        if (!this.modelData[index].name) {
          this.$message({
            type: 'info',
            message: '名称不能为空'
          })
          return
        }
        if (!(/(^[A-Za-z0-9_-]*$)/.test(this.modelData[index].name))||(/(^[0-9]*$)/.test(this.modelData[index].name.slice(0, 1)))) {
          this.$message({
            type: 'info',
            message: '参数名称只能为数字字母下划线并且第一个字符不能为数字'
          })
          return
        }
        if (!this.modelData[index].name) {
          this.$message({
            type: 'info',
            message: '类型不能为空'
          })
          return
        }
        if (!this.modelData[index].name) {
          this.$message({
            type: 'info',
            message: '是否必须不能为空'
          })
          return
        }
        if (!this.modelData[index].name) {
          this.$message({
            type: 'info',
            message: '描述不能为空'
          })
          return
        }
        this.isShowAdd = true;
        this.modelData[index].isShow = false
      },
      editDetail(index) {
        this.modelData[index].isShow = true
      },
      deleteRow(index, rows) {
        rows.splice(index, 1);
        this.isShowAdd = true
      },
      // 新增公告请求参数
      addModelDetail() {
        this.isShowAdd = false;
        this.modelData.push(JSON.parse(JSON.stringify(this.obj)))
      },
      // 错误码保存
      saveDetail2(id, index) {
        if (!this.modelData2[index].error_code) {
          this.$message({
            type: 'info',
            message: '错误码不能为空'
          })
          return
        }
        if (!this.modelData2[index].error_desc) {
          this.$message({
            type: 'info',
            message: '错误描述不能为空'
          })
          return
        }
        this.modelData2[index].doc_id = this.docId;
        if (id) {
          this.modelData2[index].id = id;
          docUpdateErrorCode(this.modelData2[index])
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功修改错误码!'
                });
                this.getDocListErrorCode()
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          docAddErrorCode(this.modelData2[index])
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功新增错误码!'
                });
                this.getDocListErrorCode()
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
        this.isShowAdd2 = true;
        this.modelData2[index].isShow2 = false
      },
      editDetail2(id, index) {
        this.modelData2[index].isShow2 = true
      },
      deleteRow2(id, index, rows) {
        if (id) {
          const title = '是否确认删除该项错误码？';
          this.$confirm(title, '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true;
            let body = {
              id: id
            }
            docErrorCodeDelete(body)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  });
                  rows.splice(index, 1);
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        } else {
          rows.splice(index, 1);
        }
        this.isShowAdd2 = true
      },
      // 新增错误码
      addModelDetail2() {
        this.isShowAdd2 = false;
        this.modelData2.push(JSON.parse(JSON.stringify(this.obj2)))
      },
      // 常见Q&A保存
      saveDetail3(id, index) {
        if (!this.modelData3[index].question) {
          this.$message({
            type: 'info',
            message: '问题不能为空'
          })
          return
        }
        if (!this.modelData3[index].solution) {
          this.$message({
            type: 'info',
            message: '解决方案不能为空'
          })
          return
        }
        this.modelData3[index].doc_id = this.docId;
        if (id) {
          this.modelData3[index].id = id;
          docUpdateQa(this.modelData3[index])
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功修改常见Q&A!'
                });
                this.getDocListQaDetail()
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          docAddQa(this.modelData3[index])
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功新增常见Q&A!'
                });
                this.getDocListQaDetail()
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
        this.isShowAdd3 = true;
        this.modelData3[index].isShow3 = false
      },
      editDetail3(id, index) {
        this.modelData3[index].isShow3 = true
      },
      deleteRow3(id, index, rows) {
        this.isShowAdd3 = true
        if (id) {
          const title = '是否确认删除该项常见Q&A？';
          this.$confirm(title, '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true;
            let body = {
              id: id
            }
            docListQaDelete(body)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  });
                  rows.splice(index, 1);
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        } else {
          rows.splice(index, 1);
        }
      },
      // 新增常见Q&A
      addModelDetail3() {
        this.isShowAdd3 = false;
        this.modelData3.push(JSON.parse(JSON.stringify(this.obj3)))
      },
      addModelDetail4() {
        this.modelData4.push(JSON.parse(JSON.stringify(this.obj4)))
      },
      addModelDetail5() {
        this.modelData5.push(JSON.parse(JSON.stringify(this.obj5)))
      },
      // 请求参数保存
      saveDetail4(index, row) {
        if (!row.name) {
          this.$message({
            type: 'info',
            message: '参数名称不能为空'
          })
          return
        }
        if (!(/(^[A-Za-z0-9_-]*$)/.test(row.name))||(/(^[0-9]*$)/.test(row.name.slice(0, 1)))) {
          this.$message({
            type: 'info',
            message: '参数名称只能为数字字母下划线并且第一个字符不能为数字'
          })
          return
        }
        if (!row.type) {
          this.$message({
            type: 'info',
            message: '类型不能为空'
          })
          return
        }
        if ((row.must !== 0&&row.must !== 1)) {
          this.$message({
            type: 'info',
            message: '是否必须不能为空'
          })
          return
        }
        row.doc_id = this.docId;
        if (row.id) {
          docUpdateReqParam(row)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功修改请求参数!'
                });
                this.$set(row, 'isShow4', false)
                this.getReqParamList()
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          docAddReqParam(row)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功新增请求参数!'
                });
                this.$set(row, 'isShow4', false)
                this.getReqParamList()
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      editDetail4(index, row) {
        this.$set(row, 'isShow4', true)
      },
      deleteRow4(index, row) {
        this.isShowAdd3 = true
        if (row.id) {
          const title = '是否确认删除该项请求参数？';
          this.$confirm(title, '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true;
            let body = {
              id: row.id
            }
            docReqParamDelete(body)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  });
                  this.delLoop(this.modelData4, row.id)
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        } else {
          this.delLoop(this.modelData4, row.id)
        }
      },
      saveDetail5(index, row) {
        if (!row.name) {
          this.$message({
            type: 'info',
            message: '参数名称不能为空'
          })
          return
        }
        if (!(/(^[A-Za-z0-9_-]*$)/.test(row.name))||(/(^[0-9]*$)/.test(row.name.slice(0, 1)))) {
          this.$message({
            type: 'info',
            message: '参数名称只能为数字字母下划线并且第一个字符不能为数字'
          })
          return
        }
        if (!row.type) {
          this.$message({
            type: 'info',
            message: '类型不能为空'
          })
          return
        }
        row.doc_id = this.docId;
        if (row.id) {
          docUpdateResParam(row)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功修改响应参数!'
                });
                this.$set(row, 'isShow5', false)
                this.getResParamList()
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          docAddResParam(row)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功新增响应参数!'
                });
                this.$set(row, 'isShow5', false)
                this.getResParamList()
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      editDetail5(index, row) {
        this.$set(row, 'isShow5', true)
      },
      deleteRow5(index, row) {
        this.isShowAdd5 = true
        if (row.id) {
          const title = '是否确认删除该项响应参数？';
          this.$confirm(title, '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true;
            let body = {
              id: row.id
            }
            docResParamDelete(body)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  });
                  this.delLoop(this.modelData5, row.id)
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        } else {
          this.delLoop(this.modelData5, row.id)
        }
      },
      // 删除递归的方法
      delLoop(arr, id) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id === id) {
            arr.splice(i, 1)
          } else if (arr[i].children) {
            arr[i].children = this.delLoop(arr[i].children, id)
          }
        }
        return arr
      },
      //table树结构删除功能
      delItem(index, row) {
        const {pid, id} = row
        // 根节点直接删除
        if (pid === '0') {
          const delIndex = this.modelData4.findIndex((item) => item.id === id)
          this.modelData4.splice(delIndex, 1)
        } else {
          // 找到父节点，通过父节点删除
          let parentRow = {}
          const findRow = (data) => {
            data.forEach((item) => {
              if (item.id === pid) {
                parentRow = {...item}
              }
              if (item.children && item.children.length) {
                findRow(item.children)
              }
            })
          }
          findRow(this.modelData4)
          const {children} = parentRow
          console.log(children)
          const delIndex = children.findIndex((item) => item.id === id)
          console.log(delIndex)
          children.splice(delIndex, 1)
        }
      },
      saveOneTab() {
        this.loading = true;
        this.infoForm.id = this.docId;
        docUpdate(this.infoForm)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '您已成功修改Api信息!'
              });
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      saveFiveTab(formName) {
        this.infoForm.id = this.docId;
        this.infoForm.resp_inst = this.fifthForm.name;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            docUpdate(this.infoForm)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '您已成功修改响应示例!'
                  });
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          }
        })
      },
      saveSixTab(formName) {
        this.infoForm.id = this.docId;
        this.infoForm.ex_inst = this.sixthForm.name;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            docUpdate(this.infoForm)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '您已成功修改异常示例!'
                  });
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          }
        })
      },
      generateResponseExamples() {
        let body = {
          id: this.docId
        }
        docInitRespInst(body)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let obj = eval("(" + res.content + ")")
              let formattedJson = JSON.stringify(obj, null, 4)
              this.fifthForm.name = formattedJson
              this.$message({
                type: 'success',
                message: '生成响应示例成功!'
              });
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      generateExceptionExamples() {
        let body = {
          id: this.docId
        }
        docInitRespInst(body)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let obj = eval("(" + res.content + ")")
              let formattedJson = JSON.stringify(obj, null, 4)
              this.sixthForm.name = formattedJson
              this.$message({
                type: 'success',
                message: '生成响应示例成功!'
              });
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      publish() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        let ids = [];
        this.selectTableData.forEach((item) => {
          ids.push(item.id)
        })
        let body = {
          ids: ids
        }
        docRelease(body)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '您已成功发布!'
              });
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
        console.log(ids)
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.attr_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .r55 .el-input__suffix {
    right: 55px !important;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  /deep/ .addForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .addForm .el-input {
    width: 320px;
  }

  /deep/ .addForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .addForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .addForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .addForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .addForm .el-input--small {
    width: 320px;
  }

  /deep/ .pswd .el-input__inner {
    padding-right: 135px;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  /deep/ .infoForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 300px;
  }

  /deep/ .infoForm .el-input--small {
    width: 300px;
  }

  /deep/ .discuss .el-textarea {
    width: 440px;
  }

  .stions {
    border-bottom: 1px solid #EBEEF5;
    padding: 8px 2px;
    text-align: center;
  }

  .ml20 {
    margin-left: 20px;
  }
</style>





// WEBPACK FOOTER //
// src/views/Document/developDocument.vue